import { Box } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import Logo from '../../components/Logo';
import { isSuperAdminOrAdmin } from './DashboardNavbar';

// ----------------------------------------------------------------------

Searchbar.propTypes = {
  isSidebarOpen: PropTypes.bool,
  isDarkModeFacility: PropTypes.bool
};

export default function Searchbar({ isSidebarOpen, isDarkModeFacility }) {
  const { user } = useAuth();
  const isAllowedUser = isSuperAdminOrAdmin(user);

  if (isSidebarOpen) return null;

  return (
    <Box
      {...(isAllowedUser ? { component: RouterLink, to: '/dashboard/maindashboard' } : {})}
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        transform: isDarkModeFacility
          ? 'scale(1)'
          : { xs: 'scale(1)', sm: 'scale(1.2)', lg: 'scale(1.3)' },
        pt: 0.2,
        pl: { xs: 0, sm: 1 }
      }}
    >
      <Logo
        darkMode={isDarkModeFacility}
        sx={
          isDarkModeFacility
            ? { width: { xs: 28, sm: 32, lg: 32 }, height: { xs: 28, sm: 32, lg: 32 } }
            : { width: { xs: 28, sm: 36, lg: 40 }, height: { xs: 28, sm: 36, lg: 40 } }
        }
      />
    </Box>
  );
}
